// export enum ViewersProductTabs {
//     ADD_REVENUE = 'ADD REVENUE',
//     PURCHASE_REVENUE = 'PURCHASE REVENUE'
// }

// export enum ViewersProjectTabs {
//     TOTAL_WATCH = 'TOTAL WATCH TIME',
//     TOTAL_INTERACTION = 'TOTAL INTERACTION TIME',
//     ADD_REVENUE = 'ADD REVENUE',
//     PURCHASE_REVENUE = 'PURCHASE REVENUE'
// }

export enum ViewersPeriodChartTabs {
    TOTAL_WATCH = 'TOTAL WATCH TIME',
    TOTAL_INTERACTION = 'TOTAL INTERACTION TIME',
    ADD_REVENUE = 'ADD REVENUE',
    PURCHASE_REVENUE = 'PURCHASE REVENUE'
}
